export enum SELECTION_TYPE {
  SINGLE = 'SINGLE',
  MULTIPLE = 'MULTIPLE',
}

export const PRODUCT_CATEGORIES_STATUS = {
  ACTIVATED: true,
  DEACTIVATED: false,
};
